import { useEffect, useRef, useState } from 'react';
import {
    Outlet, useMatch, useNavigate, useParams,
} from 'react-router-dom';
import useNavigateWithQuery from 'hooks/useNavigateWithQuery';
import useExternalAutomation from 'data/firestore/agent/externalautomation/use';
import useManageExternalAutomations from 'data/hooks/useManageExternalAutomations';
import ButtonIcon from 'components/ButtonIcon';
import ArrowLeftIcon from 'components/icons/arrowLeft';
import ExternalAutomationProfile from 'components/ExternalAutomationProfile';
import { StyledBreadcrumb, StyledBreadcrumbs } from 'components/Breadcrumbs';
import ClockIcon from 'components/icons/clock';
import {
    Columns, Container, HeaderContainer, LeftColumn, RightColumn, StyledButton, StyledCard,
    StyledTab,
    StyledTabset,
    TabLabel,
} from './styled';
import { ADD_EDIT_EXTERNAL_AUTOMATION_DRAWER } from '../../../constants';

const ExternalAutomationDetailsPage = () => {
    const { agentId = '', externalAutomationId = '' } = useParams();
    const navigate = useNavigate();
    const navigateWithQuery = useNavigateWithQuery();
    const match = useMatch(':agentId/external-automations/:externalAutomationId/:tabName');
    const [maxHeight, setMaxHeight] = useState<number>();
    const { edit } = useManageExternalAutomations({
        agentId,
        modalId: ADD_EDIT_EXTERNAL_AUTOMATION_DRAWER,
    });

    const leftColumnRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        setMaxHeight(leftColumnRef.current?.clientHeight);
    }, []);

    const { data: externalAutomation, isLoading } = useExternalAutomation(
        agentId,
        externalAutomationId,
    );

    return (
        <Container>
            <HeaderContainer>
                <ButtonIcon
                    icon={<ArrowLeftIcon />}
                    onClick={() => navigateWithQuery(`/${agentId}/external-automations`)}
                    size="small"
                />
                <StyledBreadcrumbs>
                    <StyledBreadcrumb
                        label="External Automations"
                        onClick={() => navigate(`/${agentId}/external-automations`)}
                    />
                    <StyledBreadcrumb label="External Automation Details" />
                </StyledBreadcrumbs>
            </HeaderContainer>
            <Columns ref={leftColumnRef}>
                <LeftColumn>
                    <StyledCard>
                        <ExternalAutomationProfile
                            agentId={agentId}
                            externalautomationId={externalAutomationId}
                            footer={(
                                <StyledButton
                                    label="Edit External Automation"
                                    variant="brand"
                                    shaded
                                    borderRadius="semi-rounded"
                                    onClick={() => externalAutomation && edit(externalAutomation)}
                                />
                            )}
                        />
                    </StyledCard>
                </LeftColumn>
                <RightColumn maxHeight={maxHeight}>
                    <StyledTabset
                        variant="line"
                        activeTabName={match?.params?.tabName}
                        onSelect={(event, eventName) => {
                            navigate(eventName);
                            event.preventDefault();
                        }}
                    >
                        <StyledTab
                            name="executions"
                            label={(
                                <TabLabel>
                                    <ClockIcon />
                                    Executions
                                </TabLabel>
                            )}
                        />
                    </StyledTabset>
                    <Outlet context={{ isLoading, externalAutomation }} />
                </RightColumn>
            </Columns>
        </Container>
    );
};

export default ExternalAutomationDetailsPage;
